export default {
  title: 'pink',

  twitter: '#e0245e',
  twitter_dark_hover: 'rgba(224, 36, 94, .1)',
  twitter_light_hover: '#ca2055',
}